import React, { useState } from 'react';
import './book-now.css';

// Replace with your Basin email token from https://basinapp.com
const BASIN_EMAIL_TOKEN = 'YOUR_BASIN_EMAIL_TOKEN_HERE';

export default function BookNow() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    numRooms: 1,
    numAdults: 1,
    numKids: 0,
    message: '',
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Send to Basin
      const response = await fetch('https://usebasin.com/api/v1/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: BASIN_EMAIL_TOKEN,
          data: {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            numRooms: formData.numRooms,
            numAdults: formData.numAdults,
            numKids: formData.numKids,
            message: formData.message,
          },
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send booking');
      }

      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        numRooms: 1,
        numAdults: 1,
        numKids: 0,
        message: '',
      });

      // Reset success message after 3 seconds
      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      console.error('Booking send failed:', err);
      setError('Failed to send booking request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="book-now-container">
      <div className="book-now-form-wrapper">
        <h1>Book Your Room</h1>
        <p className="subtitle">Fill in your details and we'll confirm your booking</p>

        {submitted && (
          <div className="success-message">
            ✓ Booking request sent! We'll contact you soon.
          </div>
        )}

        {error && (
          <div className="error-message">
            ✗ {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="booking-form">
          {/* Name */}
          <div className="form-group">
            <label>Full Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="John Doe"
              required
            />
          </div>

          {/* Email */}
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="john@example.com"
              required
            />
          </div>

          {/* Phone */}
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+91 98765 43210"
            />
          </div>

          {/* Number of Rooms */}
          <div className="form-group">
            <label>Number of Rooms *</label>
            <select
              name="numRooms"
              value={formData.numRooms}
              onChange={handleChange}
              required
            >
              <option value={1}>1 Room</option>
              <option value={2}>2 Rooms</option>
              <option value={3}>3 Rooms</option>
              <option value={4}>4 Rooms</option>
              <option value={5}>5 Rooms</option>
            </select>
          </div>

          {/* Number of Adults */}
          <div className="form-group">
            <label>Number of Adults *</label>
            <select
              name="numAdults"
              value={formData.numAdults}
              onChange={handleChange}
              required
            >
              <option value={1}>1 Adult</option>
              <option value={2}>2 Adults</option>
              <option value={3}>3 Adults</option>
              <option value={4}>4 Adults</option>
              <option value={5}>5+ Adults</option>
            </select>
          </div>

          {/* Number of Kids */}
          <div className="form-group">
            <label>Number of Kids</label>
            <select name="numKids" value={formData.numKids} onChange={handleChange}>
              <option value={0}>0 Kids</option>
              <option value={1}>1 Kid</option>
              <option value={2}>2 Kids</option>
              <option value={3}>3 Kids</option>
              <option value={4}>4+ Kids</option>
            </select>
          </div>

          {/* Message */}
          <div className="form-group full-width">
            <label>Additional Message / Special Requests</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Any special requests or additional information..."
              rows={4}
            ></textarea>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="submit-btn"
          >
            {loading ? 'Sending...' : 'Submit Booking'}
          </button>
        </form>

        <p className="contact-info">
          Or call us directly: <strong>+91 9490490077</strong>
        </p>
      </div>
    </div>
  );
}
